import * as echarts from "echarts";
export default function (selector, options, eventHandlers = []) {
  setTimeout(() => {
    const dom = document.querySelector(selector);
    const instance = echarts.getInstanceByDom(dom);
    // 每次都重新创建实例，这样就不用保存实例了
    instance && echarts.dispose(instance)
    const chart = echarts.init(dom);
    chart.setOption(options);
    eventHandlers.forEach(eventHandler => chart.on(eventHandler.eventName, (params) => eventHandler.handler(params, chart)));
  });
}